import { Visibility } from '@doist/icons/product-ui';
import { Box, Text } from '@doist/marketist';
import cn from 'clsx';
import { useTranslation } from 'next-i18next';
import { ProductUIButton } from '../product-ui-button/product-ui-button';
import css from './product-ui-view-header.module.css';
import type { ReactElement, ReactNode } from 'react';
type ProductUIPreviewBannerProps = {
  children: ReactNode;
  ctaWrapper?: (children: ReactElement) => ReactElement;
};
export function ProductUIPreviewBanner({
  children,
  ctaWrapper = children => children
}: ProductUIPreviewBannerProps) {
  const {
    t
  } = useTranslation('productui');
  return <Box className={cn(css.previewBanner, 'mbs-8')} data-sentry-element="Box" data-sentry-component="ProductUIPreviewBanner" data-sentry-source-file="product-ui-preview-banner.tsx">
            <Box className={css.previewBannerContent} data-sentry-element="Box" data-sentry-source-file="product-ui-preview-banner.tsx">
                <Visibility className={css.previewBannerIcon} data-sentry-element="Visibility" data-sentry-source-file="product-ui-preview-banner.tsx" />
                <Text size="minor-sm" weight="medium" className={css.previewBannerText} data-sentry-element="Text" data-sentry-source-file="product-ui-preview-banner.tsx">
                    {children}
                </Text>
            </Box>
            {ctaWrapper(<ProductUIButton>{t('join')}</ProductUIButton>)}
        </Box>;
}